







































































































































































































import Vue, { PropType } from "vue";
import { GridColumnProps } from "@progress/kendo-vue-grid";
import GridLayoutProfile from "@/models/GridLayoutProfile";
import { GridLayoutSettings } from "@/services/GridLayoutSettings";

interface Data {
  open: boolean;
  x: number;
  y: number;
  saveOpen: boolean;
  newProfileName: string;
  newProfileDefault: boolean;
  saveError: string;
  profileToDelete: string;
}

/**
 * Kendo grid elrendezés-profiljainak jobb klikk menüje: betöltés, mentés, alapértelmezett, törlés, oszlopok ki/be.
 * Az állapotot és az adatműveleteket a propként kapott GridLayoutSettings példány végzi;
 * a page-nek csak a `show(event)` metódust kell hívnia a grid contextmenu eseményére.
 * Bekötés: docs/grid-layout-bekotes.md
 */
export default Vue.extend({
  props: {
    layout: { type: Object as PropType<GridLayoutSettings>, required: true },
  },

  data(): Data {
    return {
      open: false,
      x: 0,
      y: 0,
      saveOpen: false,
      newProfileName: "",
      newProfileDefault: false,
      saveError: "",
      profileToDelete: "",
    };
  },

  computed: {
    toggleableColumns(): GridColumnProps[] {
      return this.layout.baseColumns.filter((c) => c.field && c.title?.trim());
    },
  },

  methods: {
    /** Megnyitás a kattintás / jobb klikk helyén. */
    show(event: MouseEvent): void {
      event.preventDefault();
      this.saveOpen = false;
      this.profileToDelete = "";
      this.open = false;
      this.x = event.clientX;
      this.y = event.clientY;
      this.$nextTick(() => (this.open = true));
    },

    select(profile: GridLayoutProfile): void {
      this.open = false;
      this.layout.select(profile);
    },

    setDefault(profile: GridLayoutProfile): void {
      this.layout.setDefault(profile);
    },

    /** Ugyanarra a kukára újra kattintva a sáv bezáródik. */
    confirmDelete(profile: GridLayoutProfile): void {
      this.profileToDelete = this.profileToDelete === profile.profileName ? "" : profile.profileName;
    },

    cancelDelete(): void {
      this.profileToDelete = "";
    },

    doDelete(): void {
      const name = this.profileToDelete;
      this.profileToDelete = "";
      this.open = false;
      this.layout.delete(name);
    },

    startSaveAs(): void {
      this.newProfileName = "";
      this.newProfileDefault = this.layout.profiles.length === 0;
      this.saveError = "";
      this.saveOpen = true;
      this.$nextTick(() => (this.$refs.saveNameInput as HTMLElement | undefined)?.focus());
    },

    cancelSave(): void {
      this.saveOpen = false;
      this.saveError = "";
    },

    saveAs(): void {
      const name = this.newProfileName.trim();
      if (!name) return;
      if (this.layout.profiles.some((p) => p.profileName === name)) {
        this.saveError = "Már van ilyen nevű elrendezés";
        return;
      }

      this.saveOpen = false;
      this.open = false;
      this.layout.saveAs(name, this.newProfileDefault);
    },

    saveCurrent(): void {
      this.open = false;
      this.layout.saveCurrent();
    },

    reset(): void {
      this.open = false;
      this.layout.reset();
    },
  },
});
